import React, { useState } from "react";

const languages = ['EN','PL','UA','RU']

const refs = ['about','services','feedbacks','portfolio','contact']

export const Navigation = (props) => {

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top" style={{padding:0}}>
            <img src="img/logo.jpg" style={{height:'100%'}}/>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            { props?.data?.navigation?.map((element,index) => (
              <li key={index}>
                <a href={`#${refs[index]}`} className="page-scroll">
                  {element}
                </a>
            </li>))}
            <li>
            <select
              className="form-select"
              aria-label="Default select example"
              onChange={(e) => props.data.setLanguage(e.target.value)}
              value={props.data.language} // Controlled component
            >
              {languages.map((language) => (
                <option value={language} key={language}>
                  {language}
                </option>
              ))}
            </select>

            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
